import React, { Component } from 'react'

export default class VideoBG extends Component {
    render() {
        return (
            <div className='text-center container'>
                <video autoPlay muted loop id="myVideo">
                    <source src="./video/nots.mp4" type="video/mp4"/>
                </video>
            </div>
        )
    }
}
